var $player = $('#herovideo');

window.onPlayerReady = (event) => {
    event.target.mute();
    event.target.playVideo();
}

window.onYouTubeIframeAPIReady = () => {
    var $player = $('#herovideo');

    window.player = new YT.Player('herovideo', {
        height: '',
        width: '',
        videoId: $player.data('video-id'),
        playerVars: {
            // 'start': ,
            // 'end': ,
            playlist: $player.data('video-id'),
            'autoplay': 1,
            'loop': 1,
            'controls': 0,
            'showinfo': 0,
            'modestbranding': 1,
            'rel': 0,
            'iv_load_policy': 3
        },
        events: {
            'onReady': onPlayerReady,
        }
    });

}

var loadYoutube = () => {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

if ($player.length && $player.data('video-id') && $player.is(':visible')) {

    loadYoutube();
} else {
    $player.removeClass('is--loaded');
}

